/**
 * Cliente das rotas de plano e do teaser.
 *
 * O teaser é uma requisição por VISITA à tela de planos, e isso é aceitável
 * porque do outro lado não existe modelo nenhum: são as 39 regras rodando sobre
 * o dado que o navegador já tem. Se algum dia isso mudar, muda aqui e no
 * `insightsService.gerarTeaser` ao mesmo tempo — e não deve mudar.
 */

import { API_ENDPOINTS } from '../config/api';

const responder = async (response) => {
  const data = await response.json().catch(() => ({}));
  if (!response.ok || data.success === false) {
    throw new Error(data.message || 'Erro na requisição');
  }
  return data.data || {};
};

const json = (metodo, corpo) => ({
  method: metodo,
  headers: { 'Content-Type': 'application/json' },
  credentials: 'include',
  ...(corpo ? { body: JSON.stringify(corpo) } : {})
});

/** Catálogo, plano atual, motivo do portão de IA e o último pedido feito. */
export const listarPlanos = () =>
  fetch(API_ENDPOINTS.PLANOS, { credentials: 'include' }).then(responder);

/** Registra o pedido de assinatura. NÃO cobra e NÃO ativa o plano. */
export const pedirAssinatura = (plano, origem = 'tela-planos') =>
  fetch(API_ENDPOINTS.PLANOS_INTENCAO, json('POST', { plano, origem })).then(responder);

/**
 * O sinal mais crítico da empresa, formatado para a tela de upgrade.
 *
 * Determinístico, sempre. Nunca aciona modelo — a tela de planos é visitada
 * justamente por quem não paga.
 */
export const teaser = ({ dre, balanco, adicionais }) =>
  fetch(API_ENDPOINTS.INSIGHTS_TEASER, json('POST', { dre, balanco, adicionais })).then(responder);
